module.exports = __webpack_public_path__ + "static/hero-background-ac033ccdc9d680a59dc222ee7890301e.png";